import styled from "styled-components";

export const HomeMain = styled.main``;
